<automata-automation-replacement-chips
  label="AUTOMATIONS.EDITOR.FILTERS.CAMPAIGN_DATA.TITLE"
  [dataService]="campaignSelectorService"
  [formControl]="campaignControl"
  [supportDataPassing]="false"
  [isRequired]="true"
  [multiple]="false"
  (finishedInitialLoading)="finishedLoading()"
></automata-automation-replacement-chips>
